<h2 mat-dialog-title class="tw-m-0 tw-text-lg tw-font-semibold">All copies</h2>
<div
  appGlossScroll
  mat-dialog-content
  class="tw-max-h-[70vh] tw-overflow-y-auto tw-min-w-[min(90vw,36rem)]"
>
  @for (item of data.items; track item.id) {
    <div class="tw-mb-6 tw-last:tw-mb-0">
      <div class="tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tw-mb-2">
        <span class="tw-text-xs tw-font-mono tw-text-dt-text-secondary">
          id: {{ item.id }} · vid: {{ item.vid ?? "—" }}
        </span>
        <button
          type="button"
          mat-stroked-button
          class="tw-text-xs tw-shrink-0"
          (click)="copyItem(item)"
        >
          Copy JSON
        </button>
      </div>
      <pre
        appGlossScroll
        class="tw-m-0 tw-text-xs tw-font-mono tw-max-h-48 tw-overflow-auto tw-p-3 tw-bg-neutral-900 tw-text-dt-text-disabled tw-rounded tw-whitespace-pre-wrap tw-break-words gs-dark"
        >{{ itemJson(item) }}</pre
      >
    </div>
  }
</div>
<div mat-dialog-actions class="tw-flex tw-justify-end tw-gap-2">
  <button mat-button mat-dialog-close type="button">Close</button>
</div>
